import { getMsgFromApiErr } from "@api/api";
import useRequestState from "@hooks/useRequestState";
import { useCallback, useEffect } from "react";
import getCigPendingExperienceRequests, {
  CigPendingExperienceRequest,
} from "../getCigPendingExperienceRequests";

const useGetCigPendingExperienceRequests = (autoSend?: boolean) => {
  const { reqState, setLoading, setSuccess, setError } = useRequestState<
    CigPendingExperienceRequest[]
  >([]);

  const send = useCallback(async () => {
    setLoading();
    try {
      const requests = await getCigPendingExperienceRequests();
      return setSuccess(requests);
    } catch (err: any) {
      return setError(getMsgFromApiErr(err));
    }
  }, [setError, setLoading, setSuccess]);

  useEffect(() => {
    if (autoSend) send();
    // prevents infinite loop
    // eslint-disable-next-line
  }, [autoSend]);

  return { ...reqState, data: reqState.data, send };
};

export default useGetCigPendingExperienceRequests;
